module.exports = __webpack_public_path__ + "static/athman-name-9e225fe69379263142bd5cabb777eb0a.png";